module.exports = __webpack_public_path__ + "assets/244fb9b4b0a7f9f630f9b093e527926b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level3_WinKP35V1_14.mp3
 ** module id = 393
 ** module chunks = 0
 **/